import { createWithDecorators } from "../../../../muiEditor/decorators";

export const createViewModel = raw => createWithDecorators(null, raw)
